<div>
  <ppt-actions-toolbar
    [reportData]="reportData()"
    [currentView]="currentView()"
    [templates]="templateFieldsCatalog"
    [recordsCount]="summaryRecords.length"
    [requiresRecordNavigation]="false"
    [requiresSelectTempElement]="true"
    [isUKFeaturesEnabled]="isUKFeaturesEnabled()"
    (templateAndViewChange)="onTemplateSelectedLater($event)"
  ></ppt-actions-toolbar>
</div>
<div class="map">
  <ng-container
    [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-summary-map'"
    [ngTemplateOutletContext]="{
      content: showHeader,
      summaryAddressPaths: summaryAddressPaths,
      isGroupByProperty: reportOptions().groupByBuilding,
    }"
  ></ng-container>
</div>

<ng-template #showHeader>
  <div class="map-header print-hidden">
    <span class="entity-records-info">
      <span class="entity-list"
        >{{ 'entities.' + (reportOptions().groupByBuilding ? 'property' : reportData().entity) | translate }}
        {{ 'template.list' | translate }} &nbsp;&nbsp;&nbsp; {{ summaryRecords.length }}
      </span>
      @if (reportData().records.length > 1) {
        {{ 'recordPPT.records' | translate }}
      } @else {
        {{ 'recordPPT.record' | translate }}
      }
    </span>
  </div>
</ng-template>

@if (bodyGroups?.length) {
  @if (reportData().entity !== 'tim') {
    <ul
      cdkDropList
      cdkDropListOrientation="vertical"
      (cdkDropListDropped)="onReorder($event)"
      >
      @for (record of summaryRecords; track record; let order = $index) {
        <li cdkDrag cdkDragLockAxis="y">
          @if (!reportOptions().groupByBuilding) {
            <mat-icon class="handle print-hidden" svgIcon="alt-handle-icon" color="y-icon" cdkDragHandle></mat-icon>
            <mat-icon
              class="green-close print-hidden"
              color="y-icon"
              svgIcon="close-icon-grey"
              (click)="removeRecordFromReport(record, order)"
              >
            </mat-icon>
            <ng-container
              [ngTemplateOutlet]="templateProjectionMap() | selectTemplateOutlet: 'miq-goes-to-record'"
          [ngTemplateOutletContext]="{
            classes: '',
            urlParams: record | reportRecordRouteFn: { templateId: currentView().templateId, entity: reportData().entity },
            content: goToIcon,
            reportEntity: this.reportData().entity,
            edpRecordId: record.edpRecordId,
          }"
            ></ng-container>
            <ng-template #goToIcon>
              <mat-icon class="print-hidden" color="y-icon" svgIcon="open_in_browser"></mat-icon>
            </ng-template>
          }
          <p>
            @for (field of bodyFields; track field) {
              @if (
                record
                | isFieldVisible: { templateId: currentView().templateId, field: field, reportOptions: reportOptions() }
                ) {
                <span
                  >
                  {{
                  record
                  | reportFieldFormatter
                  : { templateId: currentView().templateId, field: field, joinString: true, onlyUrl: false }
                  | async
                  }}
                </span>
              }
            }
          </p>
        </li>
      }
    </ul>
  }
} @else {
}
